import { render, staticRenderFns } from "./com-pagetabs.vue?vue&type=template&id=6eb738df"
import script from "./com-pagetabs.vue?vue&type=script&lang=js"
export * from "./com-pagetabs.vue?vue&type=script&lang=js"
import style0 from "./com-pagetabs.vue?vue&type=style&index=0&id=6eb738df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports